export enum OrderStatusEnum {
  CREATED = 'created',
  PENDING = 'pending approval',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  SHIPPED = 'shipping',
  RECEIVED = 'received',
  CHECKED_IN = 'checked in',
  DRAFT = 'draft'
}
